import * as Yup from 'yup'

export default Yup.object().shape({
	gensetSerial: Yup.string().required('Required'),
})

